import PromptCreateHomeLocation from 'Common/components/PromptCreateHomeLocation';
import { V2Gateway_QueryLocationsQueryHookResult } from 'Generated/graphql';
import { useRouter, useSearchParams } from 'next/navigation';

type locations = NonNullable<
  V2Gateway_QueryLocationsQueryHookResult['data']
>['queryLocations']['locations']
type location = Omit<locations[number], 'serviceAreas'>

type ServiceProviderPagePromptCreateLocationProps = {
  isDisabled: boolean;
  onLocationSelected: (id: string) => void;
  redirectTo: string | ((l: location) => string | null) | null;
  isOpen: boolean;
  onClose: () => void;
}

const ServiceProviderPagePromptCreateLocation: React.FC<ServiceProviderPagePromptCreateLocationProps> = ({
  isDisabled,
  onLocationSelected,
  redirectTo,
  isOpen,
  onClose,
}) => {
  const search = useSearchParams();
  const router = useRouter();

  const navigateToAppointmentRequestFlow = (l: location) => {
    if (typeof redirectTo === 'string') {
      window.location.href = search ?
        `${redirectTo}?${search.toString()}` :
        redirectTo;
    } else if (typeof redirectTo === 'function') {
      const red = redirectTo(l);
      if (red) {
        router.push(red);
      }
    }
  };

  return (
    <PromptCreateHomeLocation
      isOpen={isOpen}
      onFlowComplete={(loc) => {
        onLocationSelected(loc.id);
        navigateToAppointmentRequestFlow(loc);
      }}
      onClose={() => onClose()}
      isSubmitDisabled={isDisabled}
    />
  );
};

export default ServiceProviderPagePromptCreateLocation;

